import listActions from 'src/modules/servicio/list/servicioListActions';
import ServicioService from 'src/modules/servicio/servicioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'SERVICIO_DESTROY';

const servicioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: servicioDestroyActions.DESTROY_STARTED,
      });

      await ServicioService.destroyAll([id]);

      dispatch({
        type: servicioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.servicio.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: servicioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: servicioDestroyActions.DESTROY_ALL_STARTED,
      });

      await ServicioService.destroyAll(ids);

      dispatch({
        type: servicioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.servicio.destroyAll.success'),
      );

      getHistory().push('/servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: servicioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default servicioDestroyActions;
